import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaWhatsapp, FaTelegramPlane } from "react-icons/fa";
import { WA_LINK, TG_LINK } from "../config/contactLinks";
import { useLanguage } from "../context/LanguageContext";

function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  return (
    <footer>
    <Container fluid className="footer">
      <Row className="align-items-center py-3">
        <Col md="4" className="footer-copywright">
          <img
            src={`${process.env.PUBLIC_URL}/logo/big-logo.png`}
            alt={t("seo.siteName")}
            className="broxe-footer-logo mb-2"
          />
          <p className="text-white-50 small mb-0">{t("footer.tagline")}</p>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3 className="small mb-0">© {year} Broxe Group</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href={WA_LINK}
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("footer.ariaWa")}
              >
                <FaWhatsapp />
              </a>
            </li>
            <li className="social-icons">
              <a
                href={TG_LINK}
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("footer.ariaTg")}
              >
                <FaTelegramPlane />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
    </footer>
  );
}

export default Footer;
